import { TicketStatusTypes } from './custom.ticket.item';


export class CustomTicketsAdminTotals {
    Status: TicketStatusTypes;
    MemberID: number;
    Total: number;
}

export class CustomTicketsAdminTotalsArray extends Array<CustomTicketsAdminTotals> {

    constructor(...items: CustomTicketsAdminTotals[]) {
        super(...items);
        Object.setPrototypeOf(this, CustomTicketsAdminTotalsArray.prototype);
    }
}
